/**
 * La fabrique des `routes.ts` des lots : un écran chargé à son premier rendu, pas à la lecture de la
 * table.
 *
 * Le registre (`studentSpaceRoutes`) se lit donc sans tirer le design system — son test tourne sous
 * Jest, où Unistyles ne se charge pas — et une route allumée n'évalue que son propre écran. Le lot
 * passe un `require` paresseux de son écran, et son nom pour les outils de React.
 */
import React from "react"

import { type StudentSpaceScreenProps } from "./studentSpaceRouteTypes"

type Screen = React.ComponentType<StudentSpaceScreenProps>

export function loadedOnRender(load: () => Screen, name: string): Screen {
    const OnRender = (props: StudentSpaceScreenProps) => React.createElement(load(), props)
    OnRender.displayName = name
    return OnRender
}
